import { useTranslation } from "react-i18next";

import { FilesProps } from "../types";
import List from "./List";

const Files = ({ includedIds, excludedIds }: FilesProps) => {
    const { t } = useTranslation();

    return (
        <>
            {includedIds.length > 0 && (
                <List
                    title={t("Attributes##included files")}
                    ids={includedIds}
                />
            )}

            {excludedIds.length > 0 && (
                <List
                    title={t("Attributes##excluded files")}
                    ids={excludedIds}
                />
            )}
        </>
    );
};

export default Files;
